export const truncateMarkdown = (md: string, maxLength = 200) => {
  const noNewlines = md.replace(/\n+/g, ' ');
  return noNewlines.length > maxLength
    ? noNewlines.slice(0, maxLength).trim() + '...'
    : noNewlines;
};
